import { getKeys } from './getKeys'

export const reportsTranslations = {
  BEDS_OCCUPIED: '{{occupied}} out of {{total}} beds occupied',
  title: 'Occupancy',
  founding: 'Funding',
  foundingSub: 'Your current active {{variable}} shown by type of funding',
  currentOccupancy: 'Current occupancy',
  currentOccupancySub:
    'Your current bed occupancy based on the number of active {{variable}}',
  3: 'Change Over Time',
  overtimeSub: 'Number of {{variable}} displayed over time',
  emptyTitle: 'Start tracking occupancy insights and trends!',
  emptyDesc:
    'The number of beds and service user data will allow you to better understanding the occupancy of your services at the moment and over time.',
  btnTitle: 'Set up Bed Capacity',
  CHART_NO_DATA: 'No data to show',
  CHART_NO_LOGS_TITLE: "You haven't added any logs yet",
  CHART_NO_LOGS_IN_RANGE_TITLE: 'No logs in the selected dates',
  CHART_NO_LOGS_IN_RANGE_DESC: 'Choose a wider date range to see older logs.',
  CHART_SHOW_SAMPLE: 'Show sample chart',
  CHART_FLUIDS_AXIS: 'Fluids In / Out (ml)',
  CHART_FLUIDS_IN: 'Fluids in',
  CHART_FLUIDS_OUT: 'Fluids out',
  CHART_FOOD_AXIS: 'Portions Consumed',
  CHART_MOBILITY_TOOLTIP: 'Mobility was <bold>{{mobility}}</bold>',
  CHART_MOOD_TOOLTIP: 'Mood was <bold>{{mood}}</bold>',
  CHART_SEIZURE_AXIS: 'Frequency (no. per day)',
  CHART_STOOL_AXIS: 'Number of bowel movements',
  CHART_STOOL_OTHER: 'Other',
  CHART_STOOL_SUBTITLE: 'Bristol Stool Scale',
  // The unsuffixed key is the plural; `_one` is the singular.
  CHART_STOOL_TOOLTIP:
    '<bold>{{count}}</bold> bowel movements of <bold>{{name}}</bold>',
  CHART_STOOL_TOOLTIP_one:
    '<bold>{{count}}</bold> bowel movement of <bold>{{name}}</bold>',
  CHART_STOOL_TYPE: 'Type {{type}}',
  CHART_TITLE_FLUIDS: 'Fluids Chart',
  CHART_TITLE_FOOD: 'Food Chart',
  CHART_TITLE_SEIZURE: 'Seizure',
  CHART_TITLE_STOOL: 'Stool Chart',
  GROUP_BMI_CHART: "Today's BMI",
  GROUP_CARE_PLANS_CHART: "Today's Care Plans",
  GROUP_TO_DOS_CHART: "To-Do's Status",
  HOME_BMI_CHART: 'BMI',
  OCCUPANCY_AXIS: 'Occupant count',
  OCCUPANCY_SERIES: 'Occupancy'
}

export const reportsConstants = getKeys(reportsTranslations)
